module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAABWUlEQVQ4jY1TzVXCQBicSXI3doAVQAfagbEDDtnNUToQKxCPbHhPStAKTAlYgXQgRy/Z8eAmb4GIfLfvzfcz880uEIe1Vn3CLmMMS2rSkHwCyEniKBjQEQBIWicAJj1K3vQDjTEve73GmGtr7VNUcN/TMMZ8kcwPF3rvi6Qsy9shUNI6SZLXWOdDWKMw9f1YxKmIO+OrMcjZkFwccGi899OMZANgfTiR5C5N010n84XkdGBznlprRXIyAG4lfSfOOQKI79BxmdR1/ZwFQpNwrF3btos0TUFyBOBjwNHjqKpq7L2fAShINs65u17MYXFZlreRBXP8Poei4+2cu4rrT5p9RswTAKjr+lLS7NwuSWsAuXPusWNwHY5SRHTPYpBVVTWWVEjqvNr9I2fatm2TZVm+XC73XQg/YgZgEezadptIvkradLlz7hEYcCEadiFpKmm7Wq3e/qr7AW5Jo+beBiDAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/ico16.png
// module id = 515
// module chunks = 114276838955818